import { render, staticRenderFns } from "./HealthWatchlist.vue?vue&type=template&id=625c22dc&"
import script from "./HealthWatchlist.vue?vue&type=script&lang=js&"
export * from "./HealthWatchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports